import { useTranslations } from 'next-intl'

import { TRoomDetail } from '@/entities/room'
import { isNilOrEmptyString } from '@/shared/lib'

import { ExpandableText, Heading } from '../../common'

export type Props = Pick<TRoomDetail, 'additionalDescription'>

export const AdditionalDescription = ({ additionalDescription }: Props) => {
  const t = useTranslations('room_detail')

  if (isNilOrEmptyString(additionalDescription)) return null

  return (
    <section className="w-full space-y-3">
      <Heading>{t('additional_details.title')}</Heading>
      <ExpandableText content={additionalDescription} className="typo-body2" />
    </section>
  )
}
